import React, { forwardRef, ReactElement } from 'react';
import classNames from 'classnames';
import { RadioButton } from '@ver-uds/uswds-react';
import type { RadioButtonProps as USWDSRadioButtonProps } from '@ver-uds/uswds-react/dist/FormControls/RadioButton';

export interface IllustratedRadioButtonProps extends USWDSRadioButtonProps {
  icon: string | ReactElement;
}

const IllustratedRadioButton = forwardRef<HTMLInputElement, IllustratedRadioButtonProps>(
  ({ icon, label, className, ...rest }, ref): JSX.Element => {
    return (
      <RadioButton
        ref={ref}
        label={
          <>
            <span className="ver-radio__label-icon">{typeof icon === 'string' ? <img src={icon} alt="" /> : icon}</span>
            {label}
          </>
        }
        className={classNames('ver-radio', 'ver-radio--illustrated', className)}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...rest}
      />
    );
  },
);

export default IllustratedRadioButton;
